import { render, staticRenderFns } from "./FeaturedProduct.vue?vue&type=template&id=7c235eb8&"
import script from "./FeaturedProduct.vue?vue&type=script&lang=js&"
export * from "./FeaturedProduct.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedProduct.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports